import React from 'react';
import clsx from 'clsx';
import { StaticImage } from 'gatsby-plugin-image';

import Container from '@common/Container';
import Section from '@common/Section';
import Heading from '@common/Heading';
import Row from '@common/Row';
import Img from '@common/Image';
import RichText from '@common/RichText';

import * as styles from '@styles/modules/block.module.scss';

const ReviewsList = ({ data }) => {
  const {
    title,
    showTitle,
    list
  } = data;
  return (
    <Section>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        {list && list.map((item, index) => (
          <Row key={index} className={clsx(`flex-column border border-2 border-dark-grey-4 rounded p-4 mb-6 mb-sm-3 align-items-center mx-1 mx-md-0`, {
            'flex-sm-row': item.imagePosition === 'Left',
            'flex-sm-row-reverse': item.imagePosition === 'Right'
          })}>
            <div className="col-6 mt-n6 mt-sm-0 pb-3 pb-sm-0 col-sm-5 col-md-2">
              {item.images && item.images.map(image => (
                <Img image={image.gatsbyImageData} file={image.file} key={image.id} />
              ))}
            </div>
            <div className='p-0 col-12 col-sm-6 col-md-10 position-relative d-flex flex-column'>
              <div className={styles.ratingIcon}>
                <StaticImage src={`../../../../../images/5_stars.png`} placeholder='none' alt='' />
              </div>
              <div>
                {(item.title && item.showTitle) &&
                  <div className={styles.ratingTitle}>{item.title}</div>
                }
                {item.text &&
                  <RichText
                    json={item.text}
                    h1='mb-3'
                    h2='mb-3'
                    p='mb-3'
                    li='py-2'
                  />
                }
              </div>
            </div>
          </Row>
        ))}
      </Container>
    </Section>
  )
}

export default ReviewsList
